module.exports = __webpack_public_path__ + "img/dummy1.f5073537.svg";